
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "at",
  "es",
  "uk",
  "ru",
  "ja",
  "it",
  "nl",
  "pl",
  "fr"
]

export const localeLoaders = {
  en: [],
  de: [],
  at: [],
  es: [],
  uk: [],
  ru: [],
  ja: [],
  it: [],
  nl: [],
  pl: [],
  fr: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/92e4b3ad" /* webpackChunkName: "config_i18n_46config_46ts_92e4b3ad" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: []
    },
    {
      code: "de",
      language: "de-DE",
      _hreflang: "de-DE",
      _sitemap: "de-DE",
      files: []
    },
    {
      code: "at",
      language: "de-AT",
      _hreflang: "de-AT",
      _sitemap: "de-AT",
      files: []
    },
    {
      code: "es",
      language: "es-ES",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: []
    },
    {
      code: "uk",
      language: "uk-UA",
      _hreflang: "uk-UA",
      _sitemap: "uk-UA",
      files: []
    },
    {
      code: "ru",
      language: "ru-RU",
      _hreflang: "ru-RU",
      _sitemap: "ru-RU",
      files: []
    },
    {
      code: "ja",
      language: "ja-JP",
      _hreflang: "ja-JP",
      _sitemap: "ja-JP",
      files: []
    },
    {
      code: "it",
      language: "it-IT",
      _hreflang: "it-IT",
      _sitemap: "it-IT",
      files: []
    },
    {
      code: "nl",
      language: "nl-NL",
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: []
    },
    {
      code: "pl",
      language: "pl-PL",
      _hreflang: "pl-PL",
      _sitemap: "pl-PL",
      files: []
    },
    {
      code: "fr",
      language: "fr-FR",
      _hreflang: "fr-FR",
      _sitemap: "fr-FR",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://www.learn-atc.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: []
  },
  {
    code: "de",
    language: "de-DE",
    _hreflang: "de-DE",
    _sitemap: "de-DE",
    files: []
  },
  {
    code: "at",
    language: "de-AT",
    _hreflang: "de-AT",
    _sitemap: "de-AT",
    files: []
  },
  {
    code: "es",
    language: "es-ES",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: []
  },
  {
    code: "uk",
    language: "uk-UA",
    _hreflang: "uk-UA",
    _sitemap: "uk-UA",
    files: []
  },
  {
    code: "ru",
    language: "ru-RU",
    _hreflang: "ru-RU",
    _sitemap: "ru-RU",
    files: []
  },
  {
    code: "ja",
    language: "ja-JP",
    _hreflang: "ja-JP",
    _sitemap: "ja-JP",
    files: []
  },
  {
    code: "it",
    language: "it-IT",
    _hreflang: "it-IT",
    _sitemap: "it-IT",
    files: []
  },
  {
    code: "nl",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: []
  },
  {
    code: "pl",
    language: "pl-PL",
    _hreflang: "pl-PL",
    _sitemap: "pl-PL",
    files: []
  },
  {
    code: "fr",
    language: "fr-FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/